import React from 'react';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './utils/AuthContext';

import Home from './components/Home';
import AdUpload from './components/AdUpload';
import MoviesPage from './components/MoviesPage';
import MovieUploadPage from './components/MovieUploadPage';
import ContentFeed from './components/ContentFeed';
import ContentDetail from './components/ContentDetail';
import Header from './components/Header';
import ProductCatalog from './components/ProductCatalog';
import Cart from './components/Cart';
import OrderHistory from './components/OrderHistory';
import CarList from './components/CarList';
import CarServiceHistory from './components/CarServiceHistory';
import CarParts from './components/CarParts';
import CarLoan from './components/CarLoan';
import CarDiagnostics from './components/CarDiagnostics';
import CarDocuments from './components/CarDocuments';
import CarReminders from './components/CarReminders';
import CarMarket from './components/CarMarket';
import CarOwner from './components/CarOwner';
import CarFeedback from './components/CarFeedback';
import AdminPage from './components/AdminPage';
import AdminPasswordGuard from './components/AdminPasswordGuard';

const getAdminPortalUrl = () => String(process.env.REACT_APP_ADMIN_PORTAL_URL || '').trim();

const AdminPortalRedirect = () => {
  const portalUrl = getAdminPortalUrl();

  if (!portalUrl) {
    return <Navigate to="/home" replace />;
  }

  if (typeof window !== 'undefined') {
    window.location.assign(portalUrl);
  }

  return <div className="center-panel">Admin portal руу шилжүүлж байна...</div>;
};

const AuthenticatedRoute = ({ children }) => {
  const { loading, user } = useAuth();

  if (loading) {
    return <div className="center-panel">Уншиж байна...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

const AdminRoute = ({ children }) => {
  const { loading, user } = useAuth();

  if (loading) {
    return <div className="center-panel">Уншиж байна...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (String(user.role || '').toLowerCase() !== 'admin') {
    return <Navigate to="/home" replace />;
  }

  return children;
};


const AppLayout = ({ sharedThemeProps }) => {
  const location = useLocation();
  const showHeader = !location.pathname.startsWith('/admin-dashboard');

  return (
    <>
      {showHeader && <Header {...sharedThemeProps} />}
      <Routes>
        <Route
          path="/"
          element={
            <AuthenticatedRoute>
              <Home {...sharedThemeProps} />
            </AuthenticatedRoute>
          }
        />
        <Route
          path="/ads-upload"
          element={(
            <AdminRoute>
              <AdUpload {...sharedThemeProps} />
            </AdminRoute>
          )}
        />
        <Route path="/movies" element={<MoviesPage {...sharedThemeProps} />} />
        <Route path="/market" element={<ProductCatalog />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/orders" element={<OrderHistory />} />
        <Route path="/cars" element={<CarList />} />
        <Route path="/cars/service-history" element={<CarServiceHistory />} />
        <Route path="/cars/parts" element={<CarParts />} />
        <Route path="/cars/loan" element={<CarLoan />} />
        <Route path="/cars/diagnostics" element={<CarDiagnostics />} />
        <Route path="/cars/documents" element={<CarDocuments />} />
        <Route path="/cars/reminders" element={<CarReminders />} />
        <Route path="/cars/market" element={<CarMarket />} />
        <Route path="/cars/owner" element={<CarOwner />} />
        <Route path="/cars/feedback" element={<CarFeedback />} />
        <Route
          path="/feed"
          element={(
            <ContentFeed
              {...sharedThemeProps}
            />
          )}
        />
        <Route
          path="/content/:id"
          element={<ContentDetail {...sharedThemeProps} />}
        />
        <Route
          path="/admin-dashboard"
          element={<AdminPage />}
        />
        <Route
          path="/admin"
          element={<AdminPortalRedirect />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

const App = () => {
  const themeMode = 'day';

  const sharedThemeProps = {
    themeMode,
    themeMenuOpen: false,
    onToggleThemeMenu: () => {},
    onCloseThemeMenu: () => {},
    onApplyTheme: () => {}
  };

  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout sharedThemeProps={sharedThemeProps} />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
